import BaseCan from "../../../common/abilities/baseCan";
import Organization from "../../../common/models/organization";
import {OrganizationRoleCapability} from "../../../common/enums/roles/capabilities/organizationRoleCapability";
import UserDecorator from "../../admin/models/userDecorator";
import User from "../../../common/models/user";
import {DocumentRoleCapability} from "~/enums/roles/capabilities/documentRoleCapability";
import Form from "../../form_builder/models/form";
import License from "../../licenseBuilder/models/license";
import Certificate from "../../certificateBuilder/models/certificate";
import ObjectModel from "~/models/objectModel";
import DetailView from "~/models/detailView/detailView";
import ListView from "~/models/listViews/listView";
import PublicProfile from "~/models/publicProfile/publicProfile";
import Visualization from "~/models/visualizations/visualization";
import Dashboard from "~/models/dashboards/dashboard";
import organizations from "../../admin/components/organizations/index.vue";


export default class OrganizationSettingsCan extends BaseCan {
  constructor(user: User | UserDecorator) {
    super(user);

    const shareModels = [
      Form,
      License,
      Certificate,
      ObjectModel,
      DetailView,
      ListView,
      PublicProfile,
      Visualization,
      Dashboard,
    ];

    this.iCan('manageConnections', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageConnections);
    });

    this.iCan('shareConnections', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.shareConnections);
    });

    this.iCan('manageSettings', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageSettings);
    });

    this.iCan('manageTemplates', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageTemplates);
    });

    this.iCan('manageProfiles', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageProfiles);
    });

    this.iCan('manageDebug', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageDebug);
    });

    this.iCan('manageDataTags', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageDataTags);
    });

    this.iCan('manageDataTagReports', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.manageDataTagReports);
    });

    this.iCan('viewDataTags', Organization, organization => {
      return this.can('manageDataTags', organization) ||
          this.can('manageDataTagReports', organization)
    })

    this.iCan('managePeerOrganizations', Organization, organization => {
      return organization.hasCapability(OrganizationRoleCapability.managePeerOrganizations);
    })

    this.iCan('share', shareModels, document => {
      return document.organization.hasCapability(OrganizationRoleCapability.manageAllDocumentAndFolderSharesAndPermissions) ||
        document.hasShareCapability(user, DocumentRoleCapability.manageSharesAndPermissions);
    });

  }
}